import React, {
  memo, useState, useCallback, useMemo, useEffect
} from 'react';
import PropTypes from 'prop-types';
import Carousel, { Modal, ModalGateway } from 'react-images';

// import styled from 'styled-components';
import {
  onErrorHandler,
  ErrorBoundaryFallbackComponent,
  withErrorBoundary
} from 'components/ErrorBoundry/ErrorBoundry';

const FooterCaption = memo(({
  /* eslint-disable-next-line react/prop-types */
  currentView
}) => {
  const { caption } = currentView || {};

  return (
    <span>{caption}</span>
  );
});

const GalleryFunction = memo(({
  images,
  toggleLightboxOpen,
  controlCurrentIndex,
  open,
}) => {
  const [currentImage, setCurrentImage] = useState(0);
  const closeLightbox = useCallback((selectedIndex = 0) => {
    toggleLightboxOpen(false);
    setCurrentImage(selectedIndex);
  }, []);
  const modalStyle = useMemo(() => ({
    blanket: base => ({
      ...base,
      zIndex: '1399',
    }),
    positioner: base => ({
      ...base,
      zIndex: '1400',
    })
  }), []);

  const getAltText = useCallback(({ data, index }) => {
    if (data.caption) return data.caption;

    return `Image ${index + 1}`;
  }, []);

  useEffect(() => {
    setCurrentImage(controlCurrentIndex);
  }, [controlCurrentIndex]);

  return (
    <ModalGateway>
      {open ? (
        <Modal
          onClose={closeLightbox}
          styles={modalStyle}
        >
          <Carousel
            hideControlsWhenIdleNumber={20000}
            components={{ FooterCaption }}
            currentIndex={currentImage}
            formatters={{ getAltText }}
            views={images}
          />
        </Modal>
      ) : null}
    </ModalGateway>
  );
});

GalleryFunction.propTypes = {
  images: PropTypes.arrayOf(PropTypes.any),
  toggleLightboxOpen: PropTypes.func,
  open: PropTypes.bool,
  controlCurrentIndex: PropTypes.number,
};

GalleryFunction.defaultProps = {
  toggleLightboxOpen: () => {},
  images: [],
  open: false,
  controlCurrentIndex: 0,
};

export default withErrorBoundary(
  GalleryFunction,
  ErrorBoundaryFallbackComponent,
  onErrorHandler,
);

export {
  GalleryFunction as PureGallery
};
